<template>
  <div>
    <van-popup
      v-model="isShow"
      :close-on-popstate="true"
      position="bottom"
    >
      <slot name="title" />
      <van-row class="text-center">
        <van-col span="12">
          <van-cell
            clickable
            title="仅看直飞"
          >
            <van-checkbox
              slot="right-icon"
              v-model="filterData.direct"
              @change="$emit('update:filterData',filterData.direct)"
            />
          </van-cell>
        </van-col>
        <van-col span="12">
          <van-cell
            clickable
            title="隐藏共享"
          >
            <van-checkbox
              slot="right-icon"
              v-model="filterData.sharFlight"
              @change="$emit('update:filterData',filterData.sharFlight)"
            />
          </van-cell>
        </van-col>
      </van-row>

      <van-tree-select
        :items="filterData.items"
        :main-active-index.sync="filterData.index"
      >
        <template slot="content">
          <!-- 时间 -->
          <div v-show="filterData.index==0">
            <van-cell-group>
              <van-cell :title="$t('F223','不限')">
                <van-checkbox
                  slot="right-icon"
                  v-model="filterData.seltime"
                  @click="$emit('nolimit','seltime')"
                />
              </van-cell>
              <van-cell
                v-for="(t,index2) in filterData.depTime"
                :key="index2"
                :title="t.name"
              >
                <van-checkbox
                  slot="right-icon"
                  v-model="t.checked"
                  :name="t.name"
                  @change="$emit('get-term',0,t.name,t.checked)"
                />
              </van-cell>
            </van-cell-group>
          </div>
          <!-- 起飞降落 -->
          <div v-show="filterData.index==1">
            <van-cell> {{ $t('Form','起飞') }} </van-cell>
            <van-cell-group>
              <van-cell :title="$t('F223','不限')">
                <van-checkbox
                  slot="right-icon"
                  v-model="filterData.seldepPlane"
                  @click="$emit('nolimit','seldepPlane')"
                />
              </van-cell>
              <van-cell
                v-for="(t,index3) in filterData.depPlane"
                :key="'b'+index3"
                :title="t.name"
              >
                <van-checkbox
                  v-model="t.checked"
                  slot="right-icon"
                  :name="t.name"
                  @change="$emit('get-term',1,t.name,t.checked)"
                />
              </van-cell>
            </van-cell-group>

            <van-cell> 降落 </van-cell>
            <van-cell-group>
              <van-cell :title="$t('F223','不限')">
                <van-checkbox
                  slot="right-icon"
                  v-model="filterData.selarrPlane"
                  @click="$emit('nolimit','selarrPlane')"
                />
              </van-cell>
              <van-cell
                v-for="(t,index4) in filterData.arrPlane"
                :key="'c'+index4"
                :title="t.name"
              >
                <van-checkbox
                  v-model="t.checked"
                  slot="right-icon"
                  :name="t.name"
                  @change="$emit('get-term',2,t.name,t.checked)"
                />
              </van-cell>
            </van-cell-group>
          </div>
          <div v-show="filterData.index==4">
            <van-cell :title="$t('F223','不限')">
              <van-checkbox
                slot="right-icon"
                clickable
                v-model="filterData.selcabin"
                @click="$emit('nolimit','selcabin')"
              />
            </van-cell>
            <van-cell
              v-for="(t,index5) in filterData.canbin"
              :key="'d'+index5"
              :title="t.name"
            >
              <van-checkbox
                slot="right-icon"
                v-model="t.checked"
                :name="t.name"
                @change="$emit('get-term',3,t.name,t.checked)"
              />
            </van-cell>
          </div>
          <div v-show="filterData.index==2">
            <van-cell-group>
              <van-cell :title="$t('F223','不限')">
                <van-checkbox
                  slot="right-icon"
                  name="c"
                  v-model="filterData.selhkgs"
                  @click="$emit('nolimit','selhkgs')"
                />
              </van-cell>
              <van-cell
                v-for="(t,index6) in filterData.hkgs"
                :key="'e'+index6"
                :title="t.name"
              >
                <van-checkbox
                  slot="right-icon"
                  v-model="t.checked"
                  :name="t.name"
                  @change="$emit('get-term',4,t.name,t.checked)"
                />
              </van-cell>
            </van-cell-group>
          </div>
          <div v-show="filterData.index==3">
            <van-cell-group>
              <van-cell :title="$t('F223','不限')">
                <van-checkbox
                  slot="right-icon"
                  v-model="filterData.seltsfCity"
                  @click="$emit('nolimit','seltsfCity')"
                />
              </van-cell>
              <van-cell
                v-for="(t,index7) in filterData.tsfCity"
                :key="'e'+index7"
                :title="t.name"
              >
                <van-checkbox
                  slot="right-icon"
                  v-model="t.checked"
                  :name="t.name"
                  @change="$emit('get-term',5,t.name,t.checked)"
                />
              </van-cell>
            </van-cell-group>
          </div>
        </template>
      </van-tree-select>

      <van-row>
        <van-col span="12">
          <ld-button @click="$emit('clear')">
            重置筛选
          </ld-button>
        </van-col>
        <van-col span="12">
          <ld-button
            @click="ensure"
            main
            md
          >
            {{ $t('Display','显示结果') }}
          </ld-button>
        </van-col>
      </van-row>
    </van-popup>
  </div>
  <!--  -->
</template>
<script>
import { TreeSelect ,Popup,Checkbox,Cell,CellGroup,Icon} from 'vant'
import ldButton from 'Common/ldButton'

export default {
  name: 'TkFilter',
  components: {
    ldButton,
    [Popup.name]:Popup,
    [TreeSelect.name]:TreeSelect,
    [Checkbox.name]:Checkbox,
    [Cell.name]:Cell,
    [CellGroup.name]:CellGroup,
    [Icon.name]:Icon,
  },
  props:{
    index:{
      type:[String,Number],
      default:''
    },
    filterData:{
      type:Object,
      default:function(){
        return {}
      }
    },
  },
  data(){
    return {
      isShow:false
    }
  },
  methods:{
    toggle(){
      this.isShow=!this.isShow
    },
    ensure(){
      this.$emit('ensure')
      this.toggle()
    }
  }
}
</script>
<style lang="less" scoped>

</style>